import { Box, Typography } from "@mui/material";
import { Chip, Tooltip } from "components";
import { formatDateMMDDYYYY } from "tools/helper";

export const getActiveUnitsColumns = (t:any, createPerformanceChip:any) => [
  {
    field: 'vin',
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
           fontWeight: "bold",
          color: "#000000"
        }}
      >
        {t.VIN}
      </Typography>
    ),
    flex: 1,
    minWidth: 180,
    renderCell: (params:any) => {
      return (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="body2"
            fontFamily={'monospace'}
            fontSize={'0.8rem'}
          >
            {params.value ? params.value : t.EMPTY_VALUE}
          </Typography>
          {params.row.uniqueVin === false && (
            <Chip
              label={t.DUP_CHIP}
              color="primary"
              size="small"
              variant='filled'
              sx={{
                height: '14px',
                fontSize: '0.6rem',
                lineHeight: 1,
                color: '#fff',
                ml: 0.5,
                '& .MuiChip-label': {
                  padding: '0 4px',
                },
              }}
            />
          )}
        </Box>
      );
    },
  },
  {
    field: 'year',
    width: 80,
    renderCell: (params:any) => params.value || t.EMPTY_VALUE,
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
           fontWeight: "bold",
          color: "#000000"
        }}
      >
        {t.YEAR}
      </Typography>
    ),
  },
  {
    field: 'make',
    minWidth: 110,
    flex: 1,
    renderCell: (params:any) => {
      if (!params.value || typeof params.value !== 'string') {
        return t.EMPTY_VALUE;
      }
      const lowercased = params.value.toLowerCase();
      return lowercased.charAt(0).toUpperCase() + lowercased.slice(1);
    },
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
           fontWeight: "bold",
          color: "#000000"
        }}
      >
        {t.MAKE}
      </Typography>
    ),
  },
  {
    field: 'garagingZipCode',
    flex: 1,  
    minWidth: 110,
    renderCell: (params:any) => (
      <Typography
        height={'inherit'}
        variant={'body2'}
        alignContent={'center'}
        textAlign={'center'}
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%'
        }}
      >
        {params.value != null ? params.value : t.EMPTY_VALUE}
      </Typography>
    ),
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
           fontWeight: "bold",
          color: "#000000"
        }}
      >
        {t.GARAGING_ZIPCODE}
      </Typography>
    ),
  },
  {
    field: 'totalMiles',
    minWidth: 120,
    flex: 1,
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
           fontWeight: "bold",
          color: "#000000"
        }}
      >
        {t.TOTAL_MILES}
      </Typography>
    ),
    renderCell: (params:any) => (
      <Typography
        height={'inherit'}
        variant={'body2'}
        alignContent={'center'}
        textAlign={'center'}
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%'
        }}
      >
        {Math.round(params.value).toLocaleString()}
      </Typography>
    ),
  },
  {
    field: 'totalActiveDays',
    minWidth: 120,
    flex: 1,  
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
           fontWeight: "bold",
          color: "#000000"
        }}
      >
        {t.ACTIVE_DAYS}
      </Typography>
    ),
    renderCell: (params:any) => (
      <Typography
        height={'inherit'}
        variant={'body2'}
        alignContent={'center'}
        textAlign={'center'}
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%'
        }}
      >
        {Math.round(params.value).toLocaleString()}
      </Typography>
    ),
  },
  {
    field: 'avgMilesDays',
    width: 120,
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
          fontWeight: "bold",
          color: "#000000"
        }}
      >
        {t.AVG_MILES_DAY}
      </Typography>
    ),
    renderCell: (params:any) => (
      <Typography
        height={'inherit'}
        variant={'body2'}
        alignContent={'center'}
        textAlign={'center'}
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%'
        }}
      >
        {Math.round(params.value).toLocaleString()}
      </Typography>
    ),
  },
  {
    field: 'safetyEventsCount',
    width: 100,
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
           fontWeight: "bold",
          color: "#000000"
        }}
      >
        {t.SAFETY_EVENTS}
      </Typography>
    ),
    renderCell: (params:any) =>
      createPerformanceChip(params.value, params.value > 10),
  },
  {
    field: 'timeSpeedingPercentage',
    width: 120,
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
           fontWeight: "bold",
          color: "#000000"
        }}
      >
        {t.TIME_SPEEDING}
      </Typography>
    ),
    renderCell: (params:any) =>
      createPerformanceChip(
        params.value && `${params.value?.toFixed(2)}%`,
        params.value > 6.5
      ),
  },
  {
    field: 'latestScore',
    width: 105,
    renderCell: (params:any) => {
      let tooltipText = t.NO_UPDATE_DATE;
      if (params.row.latestScoreDate) {
        tooltipText = `${t.UPDATED_ON}${formatDateMMDDYYYY(
          params.row.latestScoreDate
        )}`;
      }
      return (
        <Tooltip title={tooltipText}>
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {params.value != null ? (
              <b>{`${params.value.toFixed(2)}`}</b>
            ) : (
              t.EMPTY_VALUE
            )}
          </div>
        </Tooltip>
      );
    },
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
           fontWeight: "bold",
          color: "#000000"
        }}
      >
        {t.CURRENT_RISK_SCORE}
      </Typography>
    ),
  },
  {
    field: 'previousScore',
    width: 110,
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
           fontWeight: "bold",
          color: "#000000"
        }}
      >
        {t.LAST_MONTH_SCORE}
      </Typography>
    ),
    renderCell: (params:any) => {
      let tooltipText = t.NO_UPDATE_DATE;
      if (params.row.previousScoreDate) {
        tooltipText = `${t.UPDATED_ON}${formatDateMMDDYYYY(
          params.row.previousScoreDate
        )}`;
      }
      return (
        <Tooltip title={tooltipText}>
          <div
            style={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              justifyContent: 'center',
            }}
          >
            <span style={{ color: '#616161' }}>
              {params.value != null ? params.value.toFixed(2) : t.EMPTY_VALUE}
            </span>
          </div>
        </Tooltip>
      );
    },
  },
  {
    field: 'scoreDifference',
    width: 105,
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
           fontWeight: "bold",
          color: "#000000"
        }}
      >
        {t.SCORE_CHANGE}
      </Typography>
    ),
    renderCell: (params:any) =>
      createPerformanceChip(
        params.value &&
          `${params.value > 0 ? '+' : ''}${params.value?.toFixed(2)}`,
        params.value < 0
      ),
  },
];